<template>
  <v-dialog v-model="showDialog" persistent max-width="1200px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <h5>{{ conjunto.nombreConjunto }}</h5>
          <v-tabs dark color="primary" show-arrows>
            <v-tabs-slider color="primary darken-4"></v-tabs-slider>

            <v-tab :href="'#tab-generales'">Generales</v-tab>
            <v-tab :href="'#tab-productos'" v-if="conjunto.conjuntoId !== 0"
              >Productos</v-tab
            >

            <v-tabs-items>
              <v-tab-item :value="'tab-generales'">
                <v-form ref="formConjunto" :v-model="true" lazy-validation>
                  <v-layout wrap class="container">
                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Nombre del conjunto"
                        v-model="conjunto.nombreConjunto"
                        placeholder="Nombre del conjunto, por ejemplo TRAJE COMPLETO, FRAG COMPLETO, etc"
                        hint="Nombre del conjunto"
                        :rules="[
                          () =>
                            !!conjunto.nombreConjunto ||
                            'El campo es requerido',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Precio renta"
                        v-model="conjunto.precioRenta"
                        :rules="[
                          (v) =>
                            !!conjunto.precioRenta || 'El campo es requerido',
                        ]"
                        prefix="$"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        label="Precio venta (opcional)"
                        v-model="conjunto.precioVenta"
                        prefix="$"
                        type="number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 class="text-md-right">
                      <v-btn
                        color="primary darken-4"
                        :loading="$store.state.operationInProgress"
                        @click="saveConjunto"
                        >Guardar conjunto</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-tab-item>
              <v-tab-item :value="'tab-productos'">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md12>
                    <conjunto-productos
                      ref="conjuntoProductos"
                      :conjunto="conjunto"
                    ></conjunto-productos>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false"
          >Cerrar ventana</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >{{ mensajeConjunto }}</v-alert
      >
      <v-alert
        :value="$store.state.fail"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
//Components
import conjuntoProductos from "@/views/conjunto-producto/ConjuntoProductos";

//Services;
import conjuntoService from "@/services/conjuntoService";

export default {
  components: {
    conjuntoProductos,
  },
  props: {
    conjunto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      mensajeConjunto: "Conjunto guardado con éxito",
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    saveConjunto() {
      let self = this;

      if (self.$refs.formConjunto.validate()) {
        self.operationStart();

        if (self.conjunto.conjuntoId === 0) {
          self.addConjunto();
        } else {
          self.updateConjunto();
        }
      }
    },
    addConjunto() {
      let self = this;

      conjuntoService
        .add(self.conjunto)
        .then((result) => {
          self.mensajeConjunto = "Conjunto guardado con éxito";
          self.operationSuccess();
          self.conjunto.conjuntoId = result.conjuntoId;
          self.$refs.conjuntoProductos.setConjuntoId(result.conjuntoId);
          //Enviar tipo producto al componente padre
          self.$emit("onConjuntoAdded", result);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateConjunto() {
      let self = this;

      conjuntoService
        .update(self.conjunto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onConjuntoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formConjunto.resetValidation();
      self.conjunto.conjuntoId = 0;
      (self.conjunto.nombreConjunto = ""),
        (self.conjunto.precioVenta = 0),
        (self.conjunto.precioRenta = 0);
    },
  },
};
</script>
